// Import custom sass, includes Bootstrap sass
import './_nav.scss';
import './_nav-item.twig';

export const name = 'nav';

export function disable() {}

const toggledClass = 'nav-list--show';
const itemToggledClass = 'nav-item--toggled';
const iconToggledClass = 'nav-item__icon--toggled';
const wrapperToggledClass = 'nav-item__wrapper--toggled';

const itemSelector = '.nav-item';
const iconSelector = '.nav-item__icon';
const iconToggleSelector = '.nav-item__icon--toggle';
const wrapperToggleSelector = '.nav-item__wrapper--toggle';
const toggleSelector = `${iconToggleSelector}, ${wrapperToggleSelector}`;
const navBarSelector = '.nav-list--0';

const mobileMenuToggleSelector = '.navbar-toggler';

const toggleEvent = 'menu-toggle';
let attached = false;

/**
 *
 * @param {HTMLElement} toggleElement
 * @param {HTMLElement} toToggle
 * @param {boolean|undefined} remove
 */
function toggle(toggleElement, toToggle, remove = undefined) {
  let toggleIcon = toggleElement;
  let toggleElementIsWrapper = false;
  if (toggleElement.matches(wrapperToggleSelector)) {
    toggleElementIsWrapper = true;
    toggleIcon = toggleElement.querySelector(iconSelector);
  }
  const navItem = toToggle.closest(itemSelector);
  if (remove === undefined) {
    toToggle.classList.toggle(toggledClass);
    toggleIcon.classList.toggle(iconToggledClass);
    if (toggleElementIsWrapper) {
      toggleElement.classList.toggle(wrapperToggledClass);
    }
    if (navItem) {
      navItem.classList.toggle(itemToggledClass);
    }
  } else if (remove) {
    toToggle.classList.remove(toggledClass);
    toggleIcon.classList.remove(iconToggledClass);
    if (toggleElementIsWrapper) {
      toggleElement.classList.remove(wrapperToggledClass);
    }
    if (navItem) {
      navItem.classList.remove(itemToggledClass);
    }
  } else {
    toToggle.classList.add(toggledClass);
    toggleIcon.classList.add(iconToggledClass);
    if (toggleElementIsWrapper) {
      toggleElement.classList.add(wrapperToggledClass);
    }
    if (navItem) {
      navItem.classList.add(itemToggledClass);
    }
  }
  document.dispatchEvent(new Event(toggleEvent));
}

function collapseAll(exceptIfParentOf = undefined) {
  Array.from(document.querySelectorAll(toggleSelector)).forEach((toggleElement) => {
    const {targetId} = toggleElement.dataset;
    const toToggle = document.getElementById(targetId);
    if (!exceptIfParentOf || (exceptIfParentOf && !toToggle.contains(exceptIfParentOf))) {
      toggle(toggleElement, toToggle, true);
    }
  });
}

function setMainMenuWidth() {
  const mainMenu = document.getElementById('main-menu-kazenmaier');
  if (mainMenu) {
    /**
     * @param {MediaQueryList} mediaQuery
     */
    const listener = (mediaQuery) => {
      const scrollbarWidth = `${window.innerWidth - document.body.clientWidth}px`;
      if (mediaQuery.matches) {
        mainMenu.style.width = `calc(100vw - ${scrollbarWidth})`;
        mainMenu.style['padding-left'] = 0;
      } else {
        mainMenu.style.removeProperty('width');
        mainMenu.style.removeProperty('padding-left');
      }
    };

    const mediaQuery = window.matchMedia('(max-width: 1140px)');
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', listener);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(listener);
    }
    document.addEventListener(toggleEvent, () => listener(mediaQuery));
    listener(mediaQuery);
  }
}

/**
 *
 * @param {Document | HTMLElement} context
 */
export function enable(context) {

  Array.from(context.querySelectorAll(toggleSelector)).filter((toggleElement) => !toggleElement.dataset.navAttached).forEach((toggleElement) => {
    toggleElement.addEventListener('click', (e) => {
      const {targetId} = toggleElement.dataset;
      const toToggle = document.getElementById(targetId);
      collapseAll(toToggle);
      toggle(toggleElement, toToggle);
      e.preventDefault();
    });
    toggleElement.dataset.navAttached = true;
  });
  if (attached) {
    return
  }
  setMainMenuWidth();
  const navbar = document.querySelector(navBarSelector);
  const mobileMenuToggle = document.querySelector(mobileMenuToggleSelector);
  document.addEventListener('click', (e) => {
    if (!((navbar && navbar.contains(e.target)) || (mobileMenuToggle && mobileMenuToggle.contains(e.target)))) {
      collapseAll();
    }
  });
  const mediaQuery = window.matchMedia('(min-width: 1140px)');
  const listener = () => {
    collapseAll();
  };
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', listener);
  } else if (mediaQuery.addListener) {
    mediaQuery.addListener(listener);
  }
  attached = true;
}

export default enable;
